import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomProductActions, OccTicketService } from '@product/data-access';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class TicketEffects {
  createTicket$: Observable<CustomProductActions.TicketRequestFail | CustomProductActions.TicketRequestSuccess> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CustomProductActions.TICKET_REQUEST),
        mergeMap((action: CustomProductActions.TicketRequest) => {
          const { payload } = action;

          return this.occTicketService.createTicket(payload).pipe(
            map(() => new CustomProductActions.TicketRequestSuccess()),
            catchError((e: unknown) => of(new CustomProductActions.TicketRequestFail(e))),
          );
        }),
      ),
    );

  constructor(
    private actions$: Actions,
    private occTicketService: OccTicketService,
  ) {}
}
